module.exports = __webpack_public_path__ + "static/media/frameByFrame2.6f2b7272.gif";